import { t } from '../../i18n/zh-TW.ts';
import type { StatusKey } from '../../storage/prefs.ts';
import { Hint } from '../../ui/Hint.tsx';

const OPTIONS: { key: StatusKey; label: string }[] = [
  { key: 'up', label: t.status.upcoming },
  { key: 'rel', label: t.status.released },
];

export function StatusSelector({ value, onChange }: { value: StatusKey[]; onChange: (v: StatusKey[]) => void }) {
  return (
    <fieldset className="status-selector">
      <legend className="sr-only">{t.status.label}</legend>
      <span className="control-label">
        <Hint text={t.status.label} content={t.status.hint} />
      </span>
      {OPTIONS.map((o) => {
        const checked = value.includes(o.key);
        const lastOne = checked && value.length === 1;
        return (
          <label
            key={o.key}
            className={checked ? 'toggle toggle-on' : 'toggle'}
            title={lastOne ? t.status.lastOne : undefined}
          >
            <input
              type="checkbox"
              checked={checked}
              disabled={lastOne}
              onChange={() => onChange(checked ? value.filter((v) => v !== o.key) : [...value, o.key])}
            />
            {o.label}
          </label>
        );
      })}
    </fieldset>
  );
}
